/**
 * @format
 */

/**
 * @import {CreativeWork} from './types';
 * @import {Gallery} from './core/model/gallery.js';
 * @import {Movie} from './moviePool/model/movie.js';
 * @import {PictureSet} from './picturePool/model/picture-set.js';
 * @import {Weblog} from './weblog/item.js';
 */

import {Portal} from './portal.js';
import {Publisher} from './publisher.js';
import {navigator} from './core/navigator.js';
import {special} from './special/special.js';
import {user} from './user/user.js';
import {Auth} from './auth/auth.js';
import {UserSettings} from './user/settings/settings.js';
import {ContentRemoval} from './core/content-removal.js';
import {service} from 'nova';
import {make} from './core/service/env.js';
import {Test} from './test.js';
import {PaymentFeature} from './payment/feature.js';
import './date.js';
import {GlobalFeed} from './feed/global.js';

/**
 * Do not use this in JS. These are global template parameters.
 */
@service
class ACNG {
  navigator = navigator;
  publisher = make(Publisher);
  portal = make(Portal);
  contentRemoval = new ContentRemoval();
  user = user;
  settings = make(UserSettings);
  auth = make(Auth);
  special = special;
  gfeed = new GlobalFeed();

  get payment() {
    return make(PaymentFeature);
  }

  /**
   * @deprecated Use {@link user.lang}
   */
  get LANG() {
    DEBUG: console.warn('deprecated `${LANG}` use `${user.lang} plz`');
    return user.lang;
  }

  /**
   * @deprecated Use {@link portal.abbr}
   */
  get PORTAL() {
    DEBUG: console.warn('deprecated `${PORTAL}` use `${portal.abbr} plz`');
    return make(Portal).abbr;
  }

  /**
   * @deprecated Use {@link user.fsk}
   */
  get FSK() {
    DEBUG: console.warn('deprecated `${FSK}` use `${user.fsk} plz`');
    return this.user.fsk;
  }

  /** @type {Test | null} */
  get test() {
    DEBUG: if (user.tester) {
      return make(Test);
    }

    return null;
  }

  /** @type {CreativeWork | null | undefined} */ feedItem;
  /** @type {Gallery | null | undefined} */ gallery;
  /** @type {Movie | null | undefined} */ movie;
  /** @type {PictureSet | null | undefined} */ pictureSet;
  /** @type {Weblog | null | undefined} */ weblog;
}

DEBUG: ACNG.DEBUG = true;

export {ACNG};
